import React, {useState} from 'react';
import Button from '../Button';
import BaseModal from './BaseModal';
import IVehicleType from '../../Foundations/Types/IVehicleType';

interface IProps {
    hide(): void;
    availableVehicleTypes: IVehicleType[];
    onSubmit: (selectedVehicle: IVehicleType) => void;
}

const SelectVehicleTypeModal: React.FC<IProps> = ({ hide, availableVehicleTypes, onSubmit }) => {
    const [selectedVehType, setSelectedVehType] = useState<IVehicleType | null>(null)

    const isItemSelected = (item: IVehicleType): boolean => {
       if (selectedVehType === null) {
           return false;
       }

       return item.type === selectedVehType.type;
    }

    const handleSelection = (item: IVehicleType): void => {
        setSelectedVehType(
            selectedVehType !== null && selectedVehType.type === item.type
            ? null
            : item
        );
    }

    const handleSubmit = (): void => {
        if (selectedVehType === null) {
            return;
        }

        onSubmit(selectedVehType);
    }

    const renderContent = () => (
        <div className="relative">
            <div className="text-sm my-2">
                These car types contain rate results. Select one to continue your search in this location.
            </div>
            <div className="py-2">
                {
                    availableVehicleTypes
                        .map((item: IVehicleType, key: number) => (
                            <div key={key} className="my-2">
                                <label
                                    className="flex items-center"
                                    onClick={(event) => {
                                            event.preventDefault();
                                            handleSelection(item);
                                        }
                                    }
                                >
                                    <input readOnly
                                           type="checkbox"
                                           className="mr-2 pointer-events-none"
                                           checked={isItemSelected(item)}
                                    />
                                    {item.label}
                                </label>
                            </div>
                        ))
                }
            </div>
            <Button
                text="Search"
                className="font-bold mt-2"
                width="w-full"
                onClick={() => handleSubmit()}
            />
        </div>
    )

    return <BaseModal hide={hide} header="Change car type" content={renderContent()} />
}

export default SelectVehicleTypeModal;
